import { FC, memo, ReactElement } from 'react'
import cn from 'classnames'

import { CryptoCurrencyId, CryptoCurrencyStaticMeta } from 'components/features/rewards/rewardsPane/types/cryptoCurrency'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { getCryptoCurrencyMetaOrNullById } from 'components/features/rewards/rewardsPane/store/selectors/currencies'
import { State } from 'interfaces/state'

import styles from 'components/features/rewards/rewardsPane/containers/CryptoCurrencyLogo/CryptoCurrencyLogo.styl'

type CryptoCurrencyLogoProps = {
  currencyId: CryptoCurrencyId
  className?: string
}

export const CryptoCurrencyLogo: FC<CryptoCurrencyLogoProps> = memo(({
  currencyId,
  className,
}): ReactElement | null => {
  const cryptoCurrencyMetaOrNull: CryptoCurrencyStaticMeta | null = useStoreSelector((state: State) => getCryptoCurrencyMetaOrNullById(state, currencyId))
  const cryptoCurrencyIconUrlOrUndefined = cryptoCurrencyMetaOrNull?.icon
  return (
    cryptoCurrencyIconUrlOrUndefined
      ? <img src={ cryptoCurrencyIconUrlOrUndefined } className={ cn(styles.image, className) } />
      : null
  )
})
